//things that make the interface cool
import * as $ from 'jquery';

export default (function () {

    $('.money-mask').inputmask({
        'alias': 'currency',
        'prefix': '$ ',
        'removeMaskOnSubmit' : true,
        'placeholder': '00'
    })

    $('.date-mask').inputmask({
        'alias': 'datetime',
        'inputFormat': "mm/yyyy",
        'outputFormat': "mm/yyyy",
        'removeMaskOnSubmit' : true,
        'placeholder': 'mm/yyyy'
    })

    $.extend({
        HSCore: {
            init: function () {
                $(document).ready(function () {
                    console.log('top');

                    $('.js-toggle-switch').each(function () {
                        var toggleSwitch = new HSToggleSwitch($(this)).init();
                    });

                    var unfold = new HSUnfold('.js-hs-unfold-invoker').init();

                    $('.js-slick-carousel').each(function() {
                          var slickCarousel = $.HSCore.components.HSSlickCarousel.init($(this));
                        });

                });
            },

            components: {}
        }


    });

    $.HSCore.init();
    $.fn.addmore = function(options) {
            var moreElement = this,
                singlePreSelectedValue = '',
                selectedValue = [],
                defaultOption = {
                    addText: 'add more',
                    removeText: 'Remote',
                    selectBoxDuplicate: true,
                    avoidDuplicationSelection: function(e) {
                        var o = e;
                        if ($.inArray($(o).val(), selectedValue) != -1) {
                            $(o).val(singlePreSelectedValue);
                            alert('Value already selected.');
                        } else {
                            var hasSelectValue = true;
                                /*dif = $.Deferred();*/
                            $.each($('.removeDuplication'), function(i, v) {
                                if ($(this).val() == 'select') {
                                    hasSelectValue = false;
                                    return false;
                                }
                                /*if (i == ($('.removeDuplication').length - 1)) {
                                    dif.resolve();
                                }*/
                            });
                            /*dif.done(function() {
                                if (hasSelectValue) {
                                    $('[data-id="more"]').show();
                                }
                            })*/
                        }
                    },
                    prevSelectedValue: function(e) {
                        var o = e;
                        selectedValue = [];
                        $.each($('.removeDuplication'), function(i, v) {
                            if ($(this).val() != 'select') {
                                selectedValue.push($(this).val());
                            }
                        });
                        singlePreSelectedValue = $(o).val();
                    }
                }
            defaultOption = $.extend(true, defaultOption, options);
            /*if (!defaultOption.selectBoxDuplicate) {
                $(moreElement).find('select').addClass('removeDuplication');
            }*/
            $('body').on('click', '[data-id="remove"]', function() {
                $(this).closest('.form-group').remove();
            });
            // $(this).find('select').prepend('<option value="select" selected>Select</option>');
            // $(moreElement).after('<a href="javascript:void(0)" data-id="more">' + defaultOption.addText + '</a>');
            $('body').on('click','[data-id="more"]',function() {
                // $('[data-id="more"]').hide();
                var dataMore = this,
                    removeDuplication = [];
                $(dataMore).before($(moreElement).clone().find('input').not('input[type="submit"]').val('').end().end().find('select.removeDuplication').focus(function() {
                    if (!defaultOption.selectBoxDuplicate) {
                        defaultOption.prevSelectedValue(this);
                    }
                }).change(function() {
                    if (!defaultOption.selectBoxDuplicate) {
                        defaultOption.avoidDuplicationSelection(this);
                    }
                }).end().append(function() {
                    // return $('<a href="javascript:void(0)" data-id="remove"> ' + defaultOption.removeText + '</a>').click(function() {
                    //     $(this).parent().remove();
                    // });
                }));
                if (!defaultOption.selectBoxDuplicate) {
                    $.each($('.removeDuplication'), function(i, v) {
                        if ($(this).val() != 'select') {
                            removeDuplication.push($(this).val());
                        }
                    });
                    $.each(removeDuplication, function(i, v) {
                        $('.removeDuplication').last().find('option[value="' + removeDuplication[i] + '"]').remove();
                    });
                }
            });
            $('.removeDuplication').focus(function(e) {
                defaultOption.prevSelectedValue(this);
            }).change(function() {
                defaultOption.avoidDuplicationSelection(this);
            });
            return this;
        }

        $('.repeatable').addmore({
                addText: 'Add',
                removeText: 'Remove',
                selectBoxDuplicate: false
            });

    // !function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.HSAddField=t():e.HSAddField=t()}(window,function(){return d={"./src/js/hs-add-field.js":function(module,__webpack_exports__,__webpack_require__){"use strict";eval('__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HSAddField; });\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\n/*\n* HSAddField Plugin\n* @version: 2.0.1 (Jul, 31 Nov 2021)\n* @author: HtmlStream\n* @event-namespace: .HSAddField\n* @license: Htmlstream Libraries (https://htmlstream.com/)\n* Copyright 2021 Htmlstream\n*/\nvar dataAttributeName = \'data-hs-add-field-options\';\nvar defaults = {\n  createTrigger: \'.js-create-field\',\n  deleteTrigger: \'.js-delete-field\',\n  limit: 5,\n  defaultCreated: 1,\n  nameSeparator: \'_\',\n  addedField: function addedField() {},\n  deletedField: function deletedField() {}\n};\n\nvar HSAddField = /*#__PURE__*/function () {\n  function HSAddField(el, options, id) {\n    _classCallCheck(this, HSAddField);\n\n    this.collection = [];\n    var that = this;\n    var elems;\n\n    if (el instanceof HTMLElement) {\n      elems = [el];\n    } else if (el instanceof Object) {\n      elems = el;\n    } else {\n      elems = document.querySelectorAll(el);\n    }\n\n    for (var i = 0; i < elems.length; i += 1) {\n      that.addToCollection(elems[i], options, id || elems[i].id);\n    }\n\n    if (!that.collection.length) {\n      return false;\n    } // initialization calls\n\n\n    that._init();\n\n    return this;\n  }\n\n  _createClass(HSAddField, [{\n    key: "_init",\n    value: function _init() {\n      var that = this;\n\n      var _loop = function _loop(i) {\n        var _$el = void 0;\n\n        var _options = void 0;\n\n        if (that.collection[i].hasOwnProperty(\'$initializedEl\')) {\n          return "continue";\n        }\n\n        _$el = that.collection[i].$el;\n        _options = that.collection[i].options;\n        _options.flags = {\n          name: \'data-name\',\n          "delete": \'data-hs-add-field-delete\'\n        };\n        _options.fieldsCount = 0;\n        _options.fieldsCount = _options.defaultCreated;\n        _options.tempalte = document.querySelector(_options.template);\n        _options.contaienr = _$el.querySelector(_options.container);\n\n        for (key = 0; key < _options.defaultCreated; key++) {\n          that.addField(_$el, _options);\n        }\n\n        _$el.addEventListener(\'click\', function (e) {\n          if (e.target.closest(_options.createTrigger)) {\n            that.addField(_$el, _options);\n          } else if (e.target.closest(_options.deleteTrigger)) {\n            that.deleteField(_$el, _options, e.target.closest(_options.deleteTrigger).getAttribute(_options.flags["delete"]));\n          }\n        });\n      };\n\n      for (var i = 0; i < that.collection.length; i += 1) {\n        var key;\n\n        var _ret = _loop(i);\n\n        if (_ret === "continue") continue;\n      }\n    }\n  }, {\n    key: "addField",\n    value: function addField($el, settings) {\n      var that = this;\n\n      if (settings.fieldsCount < settings.limit) {\n        var field = settings.tempalte.cloneNode(true);\n        field.removeAttribute(\'id\');\n        field.style.display = null;\n        settings.contaienr.appendChild(field);\n        that.updateFieldsCount($el, settings);\n        that.renderName($el, settings);\n        that.renderKeys($el, settings);\n        that.toggleCreateButton($el, settings);\n        settings.addedField(field);\n      }\n    }\n  }, {\n    key: "deleteField",\n    value: function deleteField($el, settings, index) {\n      var that = this;\n\n      if (settings.fieldsCount > 0) {\n        settings.contaienr.childNodes[index].parentNode.removeChild(settings.contaienr.childNodes[index]);\n        that.updateFieldsCount($el, settings);\n        that.renderName($el, settings);\n        that.renderKeys($el, settings);\n        that.toggleCreateButton($el, settings);\n        settings.deletedField();\n      }\n    }\n  }, {\n    key: "renderName",\n    value: function renderName($el, settings) {\n      settings.contaienr.childNodes.forEach(function (el, key) {\n        if (el.nodeName === \'#text\') return;\n        var field = el.querySelector("[".concat(settings.flags.name, "]"));\n        if (!field) return;\n        field.setAttribute(\'name\', "".concat(field.getAttribute(\'data-name\')).concat(settings.nameSeparator).concat(key));\n      });\n    }\n  }, {\n    key: "renderKeys",\n    value: function renderKeys($el, settings) {\n      settings.contaienr.childNodes.forEach(function (el, key) {\n        if (el.nodeName === \'#text\') return;\n        var deleteTrigger = el.querySelector(settings.deleteTrigger);\n        deleteTrigger ? deleteTrigger.setAttribute(settings.flags["delete"], key) : null;\n      });\n    }\n  }, {\n    key: "updateFieldsCount",\n    value: function updateFieldsCount($el, settings) {\n      settings.fieldsCount = settings.contaienr.childNodes.length;\n    }\n  }, {\n    key: "toggleCreateButton",\n    value: function toggleCreateButton($el, settings) {\n      var createTrigger = $el.querySelector(settings.createTrigger);\n\n      if (settings.fieldsCount === settings.limit) {\n        createTrigger.style.display = \'none\';\n      } else {\n        createTrigger.style.display = null;\n      }\n    }\n  }, {\n    key: "addToCollection",\n    value: function addToCollection(item, options, id) {\n      this.collection.push({\n        $el: item,\n        id: id || null,\n        options: Object.assign({}, defaults, item.hasAttribute(dataAttributeName) ? JSON.parse(item.getAttribute(dataAttributeName)) : {}, options)\n      });\n    }\n  }, {\n    key: "getItem",\n    value: function getItem(item) {\n      if (typeof item === \'number\') {\n        return this.collection[item].$initializedEl;\n      } else {\n        return this.collection.find(function (el) {\n          return el.id === item;\n        }).$initializedEl;\n      }\n    }\n  }]);\n\n  return HSAddField;\n}();\n\n\n\n//# sourceURL=webpack://HSAddField/./src/js/hs-add-field.js?')}},e={},f.m=d,f.c=e,f.d=function(e,t,n){f.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},f.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},f.t=function(t,e){if(1&e&&(t=f(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(f.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)f.d(n,i,function(e){return t[e]}.bind(null,i));return n},f.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return f.d(t,"a",t),t},f.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},f.p="",f(f.s="./src/js/hs-add-field.js").default;function f(t){if(e[t])return e[t].exports;var n=e[t]={i:t,l:!1,exports:{}};return d[t].call(n.exports,n,n.exports,f),n.l=!0,n.exports}var d,e});

    // new HSAddField('.js-add-field');
    // class HSAddField {
    //      constructor(element, config) {
    //          this.element = element;
    //          this.defaults = {
    //              createTrigger: '.js-create-field',
    //              deleteTrigger: '.js-delete-field',
    //              limit: 10,
    //              defaultCreated: 1,
    //              nameSeparator: '_',

    //              addedField: () => {
    //              },
    //              deletedField: () => {
    //              }
    //          };
    //          this.config = config;

    //          this.flags = {
    //              name: 'data-name',
    //              delete: 'data-hs-add-field-delete'
    //          };
    //          this.fieldsCount = 0;

    //      }

    //      init() {
    //          const self = this,
    //              element = this.element,
    //              dataSettings = $(element).attr('data-hs-add-field-options') ? JSON.parse($(element).attr('data-hs-add-field-options')) : {};

    //          this.config = Object.assign({}, this.defaults, this.config, dataSettings);
    //          this.fieldsCount = this.config.defaultCreated;

    //          for (var i = 0; i < this.config.defaultCreated; i++) {
    //              this.__addField(this.config)
    //          }

    //          $(this.element).on('click', this.config.createTrigger, () => {
    //              this.__addField(this.config)
    //          })

    //          $(this.element).on('click', this.config.deleteTrigger, (e) => {
    //              this.__deleteField(this.config, $(e.currentTarget).attr(this.flags.delete))
    //          })
    //          this.__updateFieldsCount();
    //          this.__renderKeys();
    //      }

    //      __addField(params) {
    //          var settings = params;

    //          if (this.fieldsCount < settings.limit) {
    //              let field = $(settings.template).find('.delivery-rule-row').clone().removeAttr('id').css({display: ''}).appendTo($(settings.container))

    //              this.__updateFieldsCount();
    //              this.__renderName();
    //              this.__renderKeys();
    //              this.__toggleCreateButton();

    //              this.config.addedField();
    //          }
    //      }

    //      __deleteField(params, index) {
    //          var settings = params;

    //          if (this.fieldsCount > 0) {
    //              $(settings.container).children()[index].remove()

    //              this.__updateFieldsCount();
    //              this.__renderName();
    //              this.__renderKeys();
    //              this.__toggleCreateButton();

    //              this.config.deletedField();
    //          }
    //      }

    //      __renderName() {
    //          $(this.config.container).children().each((i, el) => {
    //              let key = i;
    //              $(el).attr('data-index', key);
    //              $(el).find('input').each((i, el) => {
    //                  let name = $(el).attr(this.flags.name);
    //                  $(el).attr('name', `rules[${key}][` + name + ']');
    //              })
    //          })
    //      }

    //      __renderKeys() {
    //          $(this.config.container).children().find(this.config.deleteTrigger).each((i, el) => {
    //              $(el).attr(this.flags.delete, i)
    //          })
    //      }

    //      __updateFieldsCount() {
    //          this.fieldsCount = $(this.config.container).children().length;
    //      }

    //      __toggleCreateButton() {
    //          if (this.fieldsCount === this.config.limit) {
    //              $(this.config.createTrigger).fadeOut(0);
    //          } else {
    //              $(this.config.createTrigger).fadeIn(0);
    //          }
    //      }
    //  }

    $.HSCore.components.HSSlickCarousel = {
        defaults: {
            infinite: false,
            pauseOnHover: false,
            centerPadding: 0,
            lazyLoad: false,
            prevArrow: null,
            nextArrow: null,

            autoplaySpeed: 3000,
            speed: 300,
            initialDelay: 600,

            isThumbs: false,
            isThumbsProgressCircle: false,
            thumbsProgressContainer: null,
            thumbsProgressOptions: {
                color: '#000',
                width: 4
            },

            animationIn: null,
            animationOut: null,

            dotsWithIcon: null,
            dotsFromTitles: null,
            dotsAsProgressLine: false,
            hasDotsHelper: false,

            counterSelector: null,
            counterDivider: '/',
            counterClassMap: {
                current: 'slick-counter-current',
                total: 'slick-counter-total',
                divider: 'slick-counter-divider'
            }
        },

        init: function (el, options) {
            if (!el.length) return;

            var context = this,
                defaults = Object.assign({}, context.defaults),
                dataSettings = el.attr('data-hs-slick-carousel-options') ? JSON.parse(el.attr('data-hs-slick-carousel-options')) : {},
                settings = {
                    id: el.attr('id')
                };
            settings = $.extend(defaults, settings, dataSettings);
            settings = $.extend(settings, {
                customPaging: function (slider, i) {
                    var title = $(slider.$slides[i]).data('hs-slick-carousel-slide-title');

                    if (title && settings.dotsWithIcon) {
                        return '<span>' + title + '</span>' + settings.dotsWithIcon;
                    } else if (settings.dotsWithIcon) {
                        return '<span></span>' + settings.dotsWithIcon;
                    } else if (title && settings.dotsFromTitles) {
                        return '<span>' + title + '</span>';
                    } else if (title && !settings.dotsFromTitles) {
                        return '<span></span>' + '<strong class="dot-title">' + title + '</strong>';
                    } else {
                        return '<span></span>';
                    }
                }
            }, options);

            /* Start : object preparation */

            if (el.find('[data-slide-type]').length) {
                context.videoSupport(el);
            }

            el.on('init', function (event, slick) {
                context.transformOff(el, settings, event, slick);
            });

            el.on('init', function (event, slick) {
                context.setCustomAnimation(event, slick);
            });

            if (settings.animationIn && settings.animationOut) {
                el.on('init', function (event, slick) {
                    context.setSingleClass(event, slick);
                });
            }

            if (settings.dotsAsProgressLine) {
                el.on('init', function () {
                    context.setCustomLineDots(el, settings);
                });
            }

            if (settings.hasDotsHelper) {
                el.on('init', function (el, event, slick) {
                    context.setCustomDots(el, event, slick);
                });
            }

            if (settings.isThumbs) {
                if (settings.isThumbsProgressCircle) {
                    el.on('init', function (event, slick) {
                        context.setCustomProgressCircle(el, settings, event, slick);
                    });
                }

                $('#' + settings.id).on('click', '.slick-slide', function (e) {
                    e.stopPropagation();

                    context.goToTargetSlide($(this), settings);
                });
            }

            el.on('init', function (event, slick) {
                context.setCustomCurrentClass(el, event, slick);
            });

            el.on('init', function (event, slick) {
                context.setInitialCustomAnimation(event, slick);
            });

            if (settings.counterSelector) {
                el.on('init', function (event, slick) {
                    context.setCounter(settings, event, slick);
                });
            }

            /* End : object preparation */

            var newSlick = el.slick(settings);

            /* Start : custom functionality implementation */

            if ($(settings.asNavFor)[0] && $(settings.asNavFor)[0].dataset.hsSlickCarouselOptions ? JSON.parse($(settings.asNavFor)[0].dataset.hsSlickCarouselOptions).isThumbsProgress : false) {
                context.setInitialDelay(el, settings);
            }

            el.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                context.setCustomClasses(el, event, slick, currentSlide, nextSlide);
            });

            if (settings.counterSelector) {
                el.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    context.counting(settings, event, slick, currentSlide, nextSlide);
                });
            }

            el.on('afterChange', function (event, slick) {
                context.setCustomAnimation(event, slick);
            });

            if (settings.animationIn && settings.animationOut) {
                el.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                    context.animationIn(settings, event, slick, currentSlide, nextSlide);
                });

                el.on('beforeChange', function (event, slick, currentSlide) {
                    context.animationOut(settings, event, slick, currentSlide);
                });

                el.on('setPosition', function (event, slick) {
                    context.setPosition(settings, event, slick);
                });
            }

            /* End : custom functionality implementation */

            return newSlick;
        },

        // ----- Start : Preparation -----

        transformOff: function (el, params, event, slick) {
            var settings = params;

            $(slick.$slides).css('height', 'auto');

            if (settings.isThumbs && settings.slidesToShow >= $(slick.$slides).length) {
                el.addClass('slick-transform-off');
            }
        },

        setCustomAnimation: function (event, slick) {
            var slide = $(slick.$slides)[slick.currentSlide],
                animatedElements = $(slide).find('[data-hs-slick-carousel-animation]');

            slick.$slides.each(function (i) {
                if (i !== slick.currentSlide) {
                    var elements = $(this).find('[data-hs-slick-carousel-animation]');

                    $(elements).each(function () {
                        $(this).css({
                            opacity: 0
                        });
                    });
                }
            });

            $(animatedElements).each(function () {
                var animationIn = $(this).data('hs-slick-carousel-animation'),
                    animationDelay = $(this).data('hs-slick-carousel-animation-delay'),
                    animationDuration = $(this).data('hs-slick-carousel-animation-duration');

                $(this).css({
                    'animation-delay': animationDelay + 'ms',
                    'animation-duration': animationDuration + 'ms'
                });

                $(this).addClass('animated ' + animationIn).css({
                    opacity: 1
                });
            });
        },

        setInitialCustomAnimation: function (event, slick) {
            var slide = $(slick.$slides)[0],
                animatedElements = $(slide).find('[data-hs-slick-carousel-animation]');

            $(animatedElements).each(function () {
                var animationIn = $(this).data('hs-slick-carousel-animation');

                $(this).addClass('animated ' + animationIn).css('opacity', 1);
            });
        },

        setSingleClass: function (event, slick) {
            $(slick.$slides).addClass('single-slide');
        },

        setCustomDots: function (el) {
            var $dots = el.find('.js-dots');

            if (!$dots.length) return;

            $dots.append('<span class="dots-helper"></span>');
        },

        setCustomLineDots: function (el, params) {
            var $dots = el.find('[class="' + params.dotsClass + '"]'),
                $dotsItems = $dots.find('li');

            if (!$dots.length) return;

            setTimeout(function () {
                el.addClass('slick-line-dots-ready');
            });

            $dotsItems.each(function () {
                $(this).append('<span class="dot-line"><span class="dot-line-helper" style="transition-duration: ' + (params.autoplaySpeed + params.speed) + 'ms;"></span></span>');
            });
        },

        setCustomProgressCircle: function (el, params, event, slick) {
            var settings = params,
                thumbProgressElLength = 0,
                style = '<style type="text/css"></style>',
                $style = $(style);

            $(slick.$slides).each(function (i) {
                var $el = $('<span class="slick-thumb-progress"><svg version="1.1" viewBox="0 0 160 160"><path class="slick-thumb-progress__path" d="M 79.98452083651917 4.000001576345426 A 76 76 0 1 1 79.89443752470656 4.0000733121155605 Z"></path></svg></span>'),
                    $path = $el.find('svg path');
                thumbProgressElLength = parseInt($path[0].getTotalLength());

                $(slick.$slides[i]).children(settings.thumbsProgressContainer).append($el);
            });

            $style.text('.slick-thumb-progress .slick-thumb-progress__path {' +
                'opacity: 0;' +
                'fill: transparent;' +
                'stroke: ' + settings.thumbsProgressOptions.color + ';' +
                'stroke-width: ' + settings.thumbsProgressOptions.width + ';' +
                'stroke-dashoffset: ' + thumbProgressElLength + ';' +
                'stroke-dashoffset: 0px;' +
                '}' +
                '.slick-current .slick-thumb-progress .slick-thumb-progress__path {' +
                'opacity: 1;' +
                '-webkit-animation: ' + (slick.options.autoplaySpeed + slick.options.speed) + 'ms linear 0ms forwards dash;' +
                '-moz-animation: ' + (slick.options.autoplaySpeed + slick.options.speed) + 'ms linear 0ms forwards dash;' +
                '-o-animation: ' + (slick.options.autoplaySpeed + slick.options.speed) + 'ms linear 0ms forwards dash;' +
                'animation: ' + (slick.options.autoplaySpeed + slick.options.speed) + 'ms linear 0ms forwards dash;' +
                '}' +
                '@-webkit-keyframes dash {' +
                'from {stroke-dasharray: 0 ' + thumbProgressElLength + ';} ' +
                'to {stroke-dasharray: ' + thumbProgressElLength + ' ' + thumbProgressElLength + ';}' +
                '}' +
                '@-moz-keyframes dash {' +
                'from {stroke-dasharray: 0 ' + thumbProgressElLength + ';} ' +
                'to {stroke-dasharray: ' + thumbProgressElLength + ' ' + thumbProgressElLength + ';}' +
                '}' +
                '@-moz-keyframes dash {' +
                'from {stroke-dasharray: 0 ' + thumbProgressElLength + ';} ' +
                'to {stroke-dasharray: ' + thumbProgressElLength + ' ' + thumbProgressElLength + ';}' +
                '}' +
                '@keyframes dash {' +
                'from {stroke-dasharray: 0 ' + thumbProgressElLength + ';} ' +
                'to {stroke-dasharray: ' + thumbProgressElLength + ' ' + thumbProgressElLength + ';}' +
                '}'
            );

            $style.appendTo(el);
        },

        goToTargetSlide: function (el, params) {
            //Variables
            var settings = params,
                i = el.data('slick-index');

            if ($('#' + settings.id).slick('slickCurrentSlide') !== i) {
                $('#' + settings.id).slick('slickGoTo', i);
            }
        },

        setCustomCurrentClass: function (el) {
            var $dots = el.find('.js-dots');

            if (!$dots.length) return;

            $($dots[0].children[0]).addClass('slick-current');
        },

        setCounter: function (params, event, slick) {
            var settings = params;

            $(settings.counterSelector).html('<span class="' + settings.counterClassMap.current + '">1</span><span class="' + settings.counterClassMap.divider + '">' + settings.counterDivider + '</span><span class="' + settings.counterClassMap.total + '">' + slick.slideCount + '</span>');
        },

        // ----- End : Preparation -----

        // ----- Start : Custom functionality -----

        setInitialDelay: function (el, params) {
            var settings = params;

            el.slick('slickPause');

            setTimeout(function () {
                el.slick('slickPlay');
            }, settings.initialDelay);
        },

        setCustomClasses: function (el, event, slider, currentSlide, nextSlide) {
            var nxtSlide = $(slider.$slides)[nextSlide],
                slide = $(slider.$slides)[currentSlide],
                $dots = el.find('.js-dots'),
                animatedElements = $(nxtSlide).find('[data-hs-slick-carousel-animation]'),
                otherElements = $(slide).find('[data-hs-slick-carousel-animation]');

            $(otherElements).each(function () {
                var animationIn = $(this).data('hs-slick-carousel-animation');

                $(this).removeClass('animated ' + animationIn);
            });

            $(animatedElements).each(function () {
                $(this).css({
                    opacity: 0
                });
            });

            if (!$dots.length) return;

            if (currentSlide > nextSlide) {
                $($dots[0].children).removeClass('slick-active-right');

                $($dots[0].children[nextSlide]).addClass('slick-active-right');
            } else {
                $($dots[0].children).removeClass('slick-active-right');
            }

            $($dots[0].children).removeClass('slick-current');

            setTimeout(function () {
                $($dots[0].children[nextSlide]).addClass('slick-current');
            }, .25);
        },

        animationIn: function (params, event, slick, currentSlide, nextSlide) {
            var settings = params;

            $(slick.$slides).removeClass('animated set-position ' + settings.animationIn + ' ' + settings.animationOut);
        },

        animationOut: function (params, event, slick, currentSlide) {
            var settings = params;

            $(slick.$slides[currentSlide]).addClass('animated ' + settings.animationOut);
        },

        setPosition: function (params, event, slick) {
            var settings = params;

            $(slick.$slides[slick.currentSlide]).addClass('animated set-position ' + settings.animationIn);
        },

        counting: function (params, event, slick, currentSlide, nextSlide) {
            var settings = params,
                i = (nextSlide ? nextSlide : 0) + 1;

            $(settings.counterSelector).html('<span class="' + settings.counterClassMap.current + '">' + i + '</span><span class="' + settings.counterClassMap.divider + '">' + settings.counterDivider + '</span><span class="' + settings.counterClassMap.total + '">' + slick.slideCount + '</span>');
        },

        videoSupport: function (carousel) {
            if (!carousel.length) return;

            carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var slideType = $(slick.$slides[currentSlide]).data('slide-type'),
                    player = $(slick.$slides[currentSlide]).find('iframe').get(0),
                    command;

                if (slideType === 'vimeo') {
                    command = {
                        "method": "pause",
                        "value": "true"
                    }
                } else if (slideType === 'youtube') {
                    command = {
                        "event": "command",
                        "func": "pauseVideo"
                    }
                } else {
                    return false;
                }

                if (player !== undefined) {
                    player.contentWindow.postMessage(JSON.stringify(command), '*');
                }
            });
        },

        initTextAnimation: function (carousel, textAnimationSelector) {
            if (!window.TextFx || !window.anime || !carousel.length) return;

            var $text = carousel.find(textAnimationSelector);

            if (!$text.length) return;

            $text.each(function (i, el) {
                var $this = $(el);

                if (!$this.data('TextFx')) {
                    $this.data('TextFx', new TextFx($this.get(0)));
                }
            });

            carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var targets = slick.$slider
                    .find('.slick-track')
                    .children();

                var currentTarget = targets.eq(currentSlide),
                    nextTarget = targets.eq(nextSlide);

                currentTarget = currentTarget.find(textAnimationSelector);
                nextTarget = nextTarget.find(textAnimationSelector);

                if (currentTarget.length) {
                    currentTarget.data('TextFx').hide(currentTarget.data('effect') ? currentTarget.data('effect') : 'fx1');
                }

                if (nextTarget.length) {
                    nextTarget.data('TextFx').show(nextTarget.data('effect') ? nextTarget.data('effect') : 'fx1');
                }
            });
        }

        // ----- End : Custom functionality -----
    };

}());
